import React, { useEffect, useState } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import Loader from "../../../../../customComponents/CustomLoader";
import validations from "../../../../../../helpers/validations";
import { buttonStyle, isFormValid } from "../../../../../../helpers/common";

const AddUnit = () => {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");

  const [userTypedd, setUserTypedd] = useState([]);
  const userType = localStorage.getItem("UserType");
  console.log(userType);
  const businessPartnerId = localStorage.getItem("business_partner_id");

  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;

    UnitInputs.forEach((field) => {
      const value = formData[field.name];

      if (field.validation?.required && !value) {
        errors[field.name] = "This field is required";
        isValid = false;
        return;
      }

      if (
        value &&
        field.validation?.pattern &&
        !field.validation.pattern.test(value)
      ) {
        errors[field.name] = field.validation.message;
        isValid = false;
        return;
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to add this HSN code?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);
          const payload = {
            hsncode: formData.hsnname,
            hsncode_desc: formData.description,
            status: formData.status === true ? 1 : 0,
          };

          const response = await axiosInstance.post(
            "/hsncode/create",
            payload,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
              },
            },
          );

          console.log("HSN Code added successfully:", response.data);

          if (response.status === 200) {
            Swal.fire({
              title: "Success",
              text: "HSN Code added successfully!",
              icon: "success",
              confirmButtonText: "OK",
              allowOutsideClick: false,
              allowEscapeKey: false,
            }).then(() => {
              navigate("/admin/manage-logistic/hsn-code");
            });
          }
        } catch (error) {
          console.error("Error adding HSN code:", error);
          const errorMessage = error.response?.data?.message;
          Swal.fire({
            title: "Error",
            text:
              errorMessage ||
              "An error occurred while processing your request.",
            icon: "error",
            confirmButtonText: "OK",
          });
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    });
  };

  const UnitInputs = [
    {
      name: "hsnname",
      label: "HSN",
      type: "number",
      placeholder: "Enter HSN Code",
      required: true,
      gridClass: "col-lg-4",
      validation: validations.hsnName({ required: true }),
      // validation: {
      //   required: true,
      //   pattern: /^(?!0{8})[0-9]{8}$/,
      //   message: "HSN must be exactly 8 digits and cannot be all zeros",
      //   maxLength: 8,
      // },
    },
    {
      name: "description",
      label: "Description",
      placeholder: "Enter HSN Code Description",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: validations.description({ required: true }),
    },
    {
      name: "status",
      label: "Status",
      type: "toggle",

      gridClass: "col-lg-4",
    },
  ];

  const backNavigate = () => {
    navigate("/admin/manage-logistic/hsn-code");
  };

  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className="backbutton mt-2 mb-2">
              <img
                style={{ cursor: "pointer" }}
                onClick={backNavigate}
                src={backicon}
                alt="back"
              />
              <span className="backbtntitle">Add HSN Code</span>
            </div>
            <div className="form-container">
              <span className="cust-det-title mt-2 mb-2">
                Please Enter the HSN Details
              </span>
              <DynamicForm
                formConfig={UnitInputs}
                formData={formData}
                setFormData={setFormData}
                onSubmit={handleFormSubmit}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              />
            </div>
            <div className="btncontainer mt-3">
              <button
                className="submit-btn"
                disabled={
                  !isFormValid(UnitInputs, formData, validationErrors) ||
                  loading
                }
                style={buttonStyle(
                  UnitInputs,
                  formData,
                  validationErrors,
                  loading,
                )}
                onClick={() => {
                  handleFormSubmit(formData);
                }}
              >
                {loading ? "Processing..." : "Submit"}
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AddUnit;
